import ModalDialog from '../../../components/organisms/ModalDialog/ModalDialog';
import React from 'react';
import { SharedFilesMoveForm } from '../SharedFiles.types';
import { SharedFilesSharedMoveForm } from './SharedFilesSharedMoveForm';
import { useSharedFilesSelectedItemsContext } from '../context/SharedFilesSelectedItems';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type SharedFilesGlobalDownload = {
  headline: string;
  closeModal: () => void;
  form: SharedFilesMoveForm;
};

export function SharedFilesGlobalMoveForm({ closeModal, headline, form }: SharedFilesGlobalDownload) {
  const { selectedFiles, selectedDirectories } = useSharedFilesSelectedItemsContext();
  const { t } = useSonTranslation('SharedFiles');

  return (
    <ModalDialog closeModal={closeModal} headline={headline} initialFocusIndex={2}>
      <SharedFilesSharedMoveForm
        form={form}
        selectedFiles={selectedFiles}
        selectedDirectories={selectedDirectories}
        helpText={t('forms.globalMove.helpText')}
        submitButtonLabel={t('forms.globalMove.submitButton')}
        messageSuccess={t('forms.globalMove.success')}
        messageSending={t('forms.globalMove.sending')}
        messageFail={t('forms.globalMove.fail')}
        messageSuccessTranslationKey="SharedFiles:forms.globalMove.success"
      />
    </ModalDialog>
  );
}
